var $ = require('jquery');
var queryString = require('spscript').queryString;
var teaserContent = require('../teaserContent');

var create = function(containerSelector) {
	var qs = queryString.toObj();
	if (qs.loginSuccess && window.top){
		window.top.natp.modals.close({status: 1});
	}

	var selectors = {
		container: "#loginModal-container",
		form: ".natp-login-form",
	}
	setTimeout(() => {
		var $container = $(selectors.container);
		$container.html("");
		console.log("HERE!")
		$(selectors.form).appendTo(selectors.container);
		$(selectors.form).show();

		$container.append("<div class='natp-teaser-container'></div>");
		teaserContent.create(".natp-teaser-container");

	}, 1);

	// setTimeout(() => {
	// 	var $container = $(containerSelector);
	// 	var $loginContainer = $(".natp-login-container");
	// 	var $loginForm = $loginContainer.find(".natp-login-form");

	// 	$container.append($loginForm);

	// 	$container

	// 	setTimeout(() => $loginContainer.remove(), 1);
	// }, 1);
};

module.exports = { create: create };


// WEBPACK FOOTER //
// ./src/scripts/components/loginModal/index.js